import { AxiosInstance, AxiosResponse } from 'axios';
import { TLocaleAPI } from '../types/locale';
import { TTFReviewResponse, TTFSummaryResponse } from '../types/review';

export type TOtherReviewEndpoints = {
    getTFSummaryResponse: (sku: string, lang: 'en' | 'ar') => Promise<AxiosResponse<TTFSummaryResponse>>;
    getTFReviewResponse: (url: string) => Promise<AxiosResponse<TTFReviewResponse>>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TOtherReviewEndpoints => {
    /* <------= getTFSummaryResponse Implementation =------> */
    const getTFSummaryResponse = async (
        sku: string,
        lang: 'en' | 'ar' = 'en',
    ): Promise<AxiosResponse<TTFSummaryResponse>> =>
        api.get<TTFSummaryResponse>(
            `https://js.testfreaks.com/onpage/noon.com${lang === 'en' ? '' : `-${lang}`}/reviews.json?key=${sku}`,
        );

    /* <------= getTFReviewResponse Implementation =------> */
    const getTFReviewResponse = async (url: string): Promise<AxiosResponse<TTFReviewResponse>> =>
        api.get<TTFReviewResponse>(url);

    return {
        getTFSummaryResponse,
        getTFReviewResponse,
    };
};
